import { XCircle } from 'lucide-react';
import Modal from '../shared/Modal';

// Generic error modal for displaying error messages
interface GenericErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string | null;
}

const GenericErrorModal: React.FC<GenericErrorModalProps> = ({
  isOpen,
  onClose,
  errorMessage,
}) => {
  if (!isOpen) return null;
  return (
    <Modal
      onClose={onClose}
      isBackgroundTransparent={true}
      hideTopPadding={true}
    >
      <div className="p-6">
        <div className="flex items-center mb-3">
          <XCircle className="h-6 w-6 text-red-600 mr-2" />
          <h3 className="text-lg font-semibold text-red-700">เกิดข้อผิดพลาด</h3>
        </div>
        <div className="text-red-700 mb-6 text-base">
          {errorMessage}
        </div>
        <div className="flex justify-end w-full">
          <button
            onClick={onClose}
            className="px-4 py-2 text-base text-white bg-red-600 rounded-md hover:bg-red-700"
            data-cy="modal-generic-error-close-button"
          >
            ปิด
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default GenericErrorModal;